<template>
  <div class="node" :class="themeMap[form.type]">
    <img :src="image.logo" />
    <span class="label">{{ form.label }}</span>
    <!-- <span class="status">
      <img v-if="form.type === 'Init'" :src="image.success" />
      <img v-if="form.type === 'Exit'" :src="image.failed" />
      <img v-if="form.type === 'Common'" :src="image.running" />
    </span> -->
  </div>
</template>

<script>
const image = {
  logo: "https://gw.alipayobjects.com/mdn/rms_43231b/afts/img/A*evDjT5vjkX0AAAAAAAAAAAAAARQnAQ",
  success:
    "https://gw.alipayobjects.com/mdn/rms_43231b/afts/img/A*6l60T6h8TTQAAAAAAAAAAAAAARQnAQ",
  failed:
    "https://gw.alipayobjects.com/mdn/rms_43231b/afts/img/A*SEISQ6My-HoAAAAAAAAAAAAAARQnAQ",
  running:
    "https://gw.alipayobjects.com/mdn/rms_43231b/afts/img/A*t8fURKfgSOgAAAAAAAAAAAAAARQnAQ",
};

export default {
  name: "tasknode",
  inject: ["getGraph", "getNode"],
  data() {
    return {
      image,
      form: {},
      themeMap: {
        Init: "success",
        Common: "running",
        Exit: "failed",
      },
    };
  },
  watch: {
    'form.label'(val) {
      let { width, height } = this.getNode().size()
      const result = (val.length / 8).toFixed(2).match(/(\d+)\.(\d+)/)
      const m = Number(result[2]) > 0 ? Number(result[1]) + 1 : Number(result[1])
      height = 23 + (13 * m)
      this.getNode().size(width, height)
    }
  },
  mounted() {
    const self = this;
    const node = this.getNode();
    this.form = node.getData()
    // 监听数据改变事件
    node.on("change:data", ({ current }) => {
      self.form = current
    });
  },
};
</script>

<style>
/*解决框架冲突问题*/
#container .node.success {
  background-color: #fff !important;
  border: 1px solid #c2c8d5 !important;
  border-left: 4px solid #52c41a !important;
}

/* 流程相关样式 复制于官方文档 */
.node {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border: 1px solid #c2c8d5;
  border-left: 4px solid #5f95ff;
  border-radius: 4px;
  box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.06);
}
.node img {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-left: 8px;
}
.node .label {
  display: inline-block;
  flex-shrink: 0;
  width: 104px;
  margin-left: 8px;
  color: #666;
  font-size: 12px;
  line-height: 13px;
}
.node .status {
  flex-shrink: 0;
}
.node.success {
  border-left: 4px solid #52c41a;
}
.node.failed {
  border-left: 4px solid #ff4d4f;
}
.node.running .status img {
  animation: spin 1s linear infinite;
}
.x6-node-selected .node {
  border-color: #1890ff;
  border-radius: 2px;
  box-shadow: 0 0 0 4px #d4e8fe;
}
.x6-node-selected .node.success {
  border-color: #52c41a;
  border-radius: 2px;
  box-shadow: 0 0 0 4px #ccecc0;
}
.x6-node-selected .node.failed {
  border-color: #ff4d4f;
  border-radius: 2px;
  box-shadow: 0 0 0 4px #fedcdc;
}
.x6-edge:hover path:nth-child(2) {
  stroke: #1890ff;
  stroke-width: 1px;
}

.x6-edge-selected path:nth-child(2) {
  stroke: #1890ff;
  stroke-width: 1.5px !important;
}

@keyframes running-line {
  to {
    stroke-dashoffset: -1000;
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
